exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input:focus + div[data-v-20882ba0] {\n  outline: auto;\n  outline: -webkit-focus-ring-color auto 1px;\n}\n", ""]);

// exports
